module.exports = __webpack_public_path__ + "assets/img/rightimg.49e62b2e.png";